export default function Spinner() {
    return <div className="loader__spinner"/>;
}
